import styled from 'styled-components';

export const ChecklistContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem;
  display: grid;
  justify-content: center;
`
